import React from 'react'
import styled from 'styled-components'
import { Row } from 'components/common/layout'

export const ProgressBar: React.FC<{
  total: number
  progress: number
}> = ({ total, progress }) => {
  const arr = []
  for (let i = 0; i < total; i++) {
    arr.push(i)
  }
  return (
    <Row style={{ width: '100%', gap: 4 }}>
      {arr.map((item) => (
        <ProgressStick key={item} isSelected={progress > item} />
      ))}
    </Row>
  )
}

const ProgressStick = styled.div<{ isSelected: boolean }>`
  height: 8px;
  width: 100%;
  background-color: ${(p) =>
    p.isSelected ? p.theme.color.primary5 : p.theme.color.gray3};
`
